import type { GiftDetailActivityDto } from '@/api/types/gift';

export const GIFT_ACTIVITY_TYPES = {
  minimumPurchase: 'minimumPurchase',
  purchase: 'purchase',
} as const;

export type GiftActivityType = (typeof GIFT_ACTIVITY_TYPES)[keyof typeof GIFT_ACTIVITY_TYPES];

export const getGiftActivityType = (
  activity: Pick<GiftDetailActivityDto, 'activity_type' | 'activity_type_key'>,
): GiftActivityType | undefined => {
  if (activity.activity_type === 4 || activity.activity_type === 5) {
    return GIFT_ACTIVITY_TYPES.minimumPurchase;
  }

  if (activity.activity_type === 2 || activity.activity_type === 3) {
    return GIFT_ACTIVITY_TYPES.purchase;
  }

  if (
    activity.activity_type_key === 'full_gift' ||
    activity.activity_type_key === 'full_stair_gift'
  ) {
    return GIFT_ACTIVITY_TYPES.minimumPurchase;
  }

  if (
    activity.activity_type_key === 'buy_gift' ||
    activity.activity_type_key === 'buy_stair_gift'
  ) {
    return GIFT_ACTIVITY_TYPES.purchase;
  }

  return undefined;
};
